export default function isFilledArray(array) {
    return Array.isArray(array) && array.length > 0;
}
